import React from 'react';
import PropTypes from 'prop-types';
import styles from './tabUrl.module.scss';

function TabUrl({ slideTo, title, index, swiperIndex }) {
  return (
    <div
      onClick={() => slideTo(index)}
      onKeyDown={() => slideTo(index)}
      role="presentation"
      className={
        index !== swiperIndex
          ? styles.tabItem
          : `${styles.tabItem} ${styles.tabItemSelected}`
      }
    >
      <div className={styles.tabItemText}>{title}</div>
    </div>
  );
}

TabUrl.propTypes = {
  slideTo: PropTypes.func,
  title: PropTypes.string,
  index: PropTypes.number,
  swiperIndex: PropTypes.number,
};

export default TabUrl;
